module.exports = __webpack_public_path__ + "img/yjaq1.5a91cb99.png";